// extracted by mini-css-extract-plugin
module.exports = {"graph":"SectorCard_graph__xLvFh","grid":"SectorCard_grid__YhsJV","data":"SectorCard_data__VA0VF"};